module.exports = __webpack_public_path__ + "img/8an-rooster.ec541bfe.jpg";